import { gql } from "@apollo/client";

export const UPDATE_INVOICE_SERVICE_TYPE = gql`
  mutation updateInvoiceServiceType($input: UpdateInvoiceServiceTypeInput!) {
    invoice {
      updateInvoiceServiceType(input: $input) {
        success
      }
    }
  }
`;
